import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { putDataPromise } from 'brock-fetch-utils';
import {
    AnimatedLoader,
    HorizontalFlex,
    PadContainer,
    PageActionMenu,
    Toggle,
    Toggles,
} from 'smartsuite-ui';
import DashboardContext from '../shared/hooks/dashboardContext';
import { customDashboardModes } from '../shared/constants/constants';
import EditorErrorModal from './EditorErrorModal';
import { useLabelContext } from '../shared/hooks/labelContext';

// eslint-disable-next-line complexity
export default function CustomDashboardHeader(props) {
    const {
        uriConstants: { auditLogUri, pageHelpUri },
    } = useContext(DashboardContext);
    const { dashboardLabels, translationLabels } = useLabelContext();

    function onActionClick(description) {
        putDataPromise(auditLogUri, {
            message: `Page action selected on ${props.title}: ${description}.`,
        });
    }
    const [showEditorErrorModal, setShowEditorErrorModal] = useState(false);

    return (
        <div className="dashboard-header">
            <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                <div className="dashboard-header__title-wrapper">
                    <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                        <span className="dashboard-header__title">
                            {props.title}
                        </span>
                        {props.isModified && (
                            <label className="label dashboard-header__subtitle">
                                {dashboardLabels.modified}
                            </label>
                        )}
                    </HorizontalFlex>
                </div>
                <div className="dashboard-header__toggles">
                    <Toggles cssClassModifiers={['flex-wrap']}>
                        <Toggle
                            isActive={props.mode === customDashboardModes.view}
                            disabled={props.mode === customDashboardModes.view}
                            onClick={() => {
                                if (props.dashboardHasErrors) {
                                    setShowEditorErrorModal(true);
                                } else {
                                    props.toggleView();
                                }
                            }}
                        >
                            {dashboardLabels.preview}
                        </Toggle>
                        <Toggle
                            isActive={props.mode === customDashboardModes.edit}
                            disabled={props.mode === customDashboardModes.edit}
                            onClick={() => props.toggleEdit()}
                        >
                            {translationLabels.edit}
                        </Toggle>
                    </Toggles>
                </div>
            </HorizontalFlex>
            <div className="dashboard-header__page-actions">
                {props.isMetricDataLoading && (
                    <PadContainer cssClassModifiers={['pad-medium']}>
                        <AnimatedLoader />
                    </PadContainer>
                )}
                {props.pageActions && (
                    <PageActionMenu
                        pageHelpUrl={pageHelpUri(props.onlineHelpId)}
                        pageActions={props.pageActions}
                        onActionClick={onActionClick}
                    />
                )}
            </div>
            {showEditorErrorModal && (
                <EditorErrorModal
                    onClose={() => setShowEditorErrorModal(false)}
                />
            )}
        </div>
    );
}

CustomDashboardHeader.propTypes = {
    dashboardHasErrors: PropTypes.bool,
    isMetricDataLoading: PropTypes.bool,
    isModified: PropTypes.bool.isRequired,
    mode: PropTypes.string.isRequired,
    onlineHelpId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pageActions: PropTypes.instanceOf(Array),
    toggleEdit: PropTypes.func,
    toggleView: PropTypes.func,
    title: PropTypes.string.isRequired,
};

CustomDashboardHeader.defaultProps = {
    isMetricDataLoading: false,
};
